// extracted by mini-css-extract-plugin
export var authorCard = "M_cn";
export var authorCardContent = "M_cq";
export var authorCardImage = "M_cp";
export var bottom = "M_cw";
export var description = "M_cv";
export var name = "M_cs";
export var role = "M_ct";
export var top = "M_cr";